module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "code"
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26572a70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/CollectorCheckout.vue
// module id = 924
// module chunks = 0